import lazyAssetsObserver from 'js/lib/lazy_assets';
import SearchResultCards from 'js/searches/search_result_cards';

const LpBoclipsViewAllHelper = {
  showThreeItemsPerRow(context, items) {
    return this._showItemsPerRow(context, 3, items);
  },

  _showItemsPerRow(context, howManyPerRow, items) {
    if (!items) {
      items = [];
    }
    const boclipsStore = context.getStore('VideoModeStore');
    const storeState = boclipsStore.currentState();
    if (!storeState.viewFull && storeState.viewAll) {
      const bcResults = $('.bc-video-wrap .bc-video-card');
      const lpResults = $('.lp-video-wrap .lp-video-card');
      if (
        bcResults.length % howManyPerRow != 0 &&
        bcResults.length > howManyPerRow &&
        lpResults.length > 0
      ) {
        var last_item = $('.bc-video-wrap').children().last();
        items.push(last_item.clone(true, true));
        last_item.remove();
        this._showItemsPerRow(context, howManyPerRow, items);
      } else if (
        bcResults.length % howManyPerRow != 0 &&
        bcResults.length < howManyPerRow &&
        lpResults.length > 0
      ) {
        var last_item = $('.bc-video-wrap').children().last();
        items.push(last_item.clone(true, true));
        last_item.remove();
        this._showItemsPerRow(context, howManyPerRow, items);
      } else {
        this._prependToLpItems(context, items);
      }
    }
  },

  _prependToLpItems(context, items) {
    const boclipsStore = context.getStore('VideoModeStore');
    const storeState = boclipsStore.currentState();
    if (!storeState.viewFull && storeState.viewAll) {
      $.each(items, function (index, item) {
        item.prepend(
          $('<div>').append("<div class='resource-card-loader'></div>").html()
        );
        $('.lp-video-wrap').prepend(item);
      });
      lazyAssetsObserver.observe();
      SearchResultCards.allowToBeAddedToCollections();
    }
  }
};

if (LP && LP.module('LpBoclips')) {
  LP.module('LpBoclips').LpBoclipsViewAllHelper = LpBoclipsViewAllHelper;
}
